export default {
    computed: {
        getFBAInventoryType () {
            return [
                {
                    label: "Normal FBA inventory",
                    value: 1
                },
                {
                    label: "Remote Fullfillment with FBA without inventory",
                    value: 2
                }
            ];
        }
    }
}